import { createClient } from "@supabase/supabase-js";
import { Database } from "@shared/database.types";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://xnwouwavvdfjewsbyvkb.supabase.co";
const supabaseKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhud291d2F2dmRmamV3c2J5dmtiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA0OTk0NzEsImV4cCI6MjA5NjA3NTQ3MX0.DSLQq85VMuCqvBx-oKyC41qtiI7zeZYVQ2kfHN-vfUc";

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});
